import { http } from '@/environment/environment';
import { Notification } from '@/_models/Notification';
import store from '@/store/index';
// import { Helper } from "@/utils/Helper";
export class NotificationService{
  async getNotification(skip: number, limit: number): Promise<Notification[]> {
    try{
      const userObj = store.getters['auth/user'];
      const jwtToken = store.getters['auth/jwtToken']
      http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
      const fetchedGames = await http.get(`users/${userObj.userId}/notifications?skip=${skip}&limit=${limit}&unreadOnly=true`);
      return fetchedGames.data.viewModel;
    }catch(err){
      // Helper.endpointErrorHandling(err);
      return [];
    }
  }

  async getReadNotification(param: string): Promise<Notification[]> {
    try{
      const userObj = store.getters['auth/user'];
      const jwtToken = store.getters['auth/jwtToken']
      http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
      const fetchedGames = await http.patch(`users/${userObj.userId}/notifications?${param}`);
      return fetchedGames.data.viewModel;
    }catch(err){
      console.log(err)
      return [];
    }
  }
}